export const Dishes = [
    {
        "id": 1,
        "price": 40000,//////////////////
        "amount": 12,
        "name": "Соф салат",
        "category": "salads",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=scuwgbpy5"
    },
    {
        "id": 2,
        "price": 15000,//////////////////
        "amount": 12,
        "name": "Холодец",
        "category": "salads",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=f373tvqdp"
    },
    {
        "id": 3,
        "price": 24000,//////////////////
        "amount": 12,
        "name": "Под шуба",
        "category": "salads",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=ubqaxpsmh"
    },
    {
        "id": 4,
        "price": 23000,//////////////////
        "amount": 12,
        "name": "Мимоза",
        "category": "salads",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=ake7d9akz"
    },
    {
        "id": 5,
        "price": 32000,
        "amount": 12,
        "name": "греческий салат",
        "category": "salads",
        "desc": "Огурцы,Помидоры,Маслины,Оливки,Сыр фетаки,Лола росса,Айсберг,Лист салата,Соус,Лимон.",
        "image": "https://files.fm/thumb_show.php?i=qeqpmgy8f"
    },
    {
        "id": 153,
        "price": 35000,
        "amount": 12,
        "name": "Острый айсберг",
        "category": "salads",
        "desc": "",
        "image": "https://files.fm/thumb_show.php?i=pnpfk3t39"
    },
    {
        "id": 154,
        "price": 45000,
        "amount": 12,
        "name": "Салат Тулум",
        "category": "salads",
        "desc": "",
        "image": "https://files.fm/thumb_show.php?i=mcreuw4bd"
    },
    {
        "id": 155,
        "price": 20000,
        "amount": 12,
        "name": "Окрошка",
        "category": "salads",
        "desc": "",
        "image": "https://files.fm/thumb_show.php?i=7edegc98n"
    },
    {
        "id": 156,
        "price": 25000,
        "amount": 12,
        "name": "Кукси",
        "category": "salads",
        "desc": "",
        "image": "https://files.fm/thumb_show.php?i=kf3hr27ab"
    },
    {
        "id": 6,
        "price": 30000,
        "amount": 12,
        "name": "Оливье",
        "category": "salads",
        "desc": "Картофел,Морковь,Мясо отварное,Малосольные огурцы,Горошек,Яйцо,Майонез.",
        "image": "https://files.fm/thumb_show.php?i=pf7uutzut"
    },
    {
        "id": 7,
        "price": 31000,
        "amount": 12,
        "name": "Японский",
        "category": "salads",
        "desc": "Огурцы,Помидоры,Отварное мясо,Светофор перец,Маркавча,Зелёный лук,Оливковое масло,Чили и соевый соус.",
        "image": "https://files.fm/thumb_show.php?i=pwk354mnu"
    },
    {
        "id": 8,
        "price": 29000,
        "amount": 12,
        "name": "баклажан смак",
        "category": "salads",
        "desc": "Баклажан,Помидоры,Зелёный лук,Кинза,Оливковое масло",
        "image": "https://files.fm/thumb_show.php?i=c5hue6h6m"
    },
    {
        "id": 9,
        "price": 21000,
        "amount": 12,
        "name": "Винегред",
        "category": "salads",
        "desc": "Свёкла\n" +
            "Морковь \n" +
            "Картофель\n" +
            "Горох\n" +
            "Малосольные огурцы\n" +
            "Квашеная капуста\n" +
            "Оливковое масло",
        "image": "https://files.fm/thumb_show.php?i=w7jdvzse5"
    },
    {
        "id": 10,
        "price": 25000,
        "amount": 12,
        "name": "Французский",
        "category": "salads",
        "desc": "Мясо отварное, морковь, картофель пай, свекла, огурцы, капуста, майонез.",
        "image": "https://files.fm/thumb_show.php?i=s745y445w"
    },
    {
        "id": 11,
        "price": 25000,
        "amount": 12,
        "name": "Смак",
        "category": "salads",
        "desc": "Помидоры \n" +
            "Сыр\n" +
            "Лист салата \n" +
            "Сухари\n" +
            "Чеснок Майонез",
        "image": "https://files.fm/thumb_show.php?i=mdce3wwjq"
    },
    {
        "id": 12,
        "price": 36000,
        "amount": 12,
        "name": "Мужской каприз",
        "category": "salads",
        "desc": "Индейка копченая, колбаса копченая, огурцы свежие, сыр, мясо конина, майонез.",
        "image": "https://files.fm/thumb_show.php?i=uxcpk3aq7"
    },
    {
        "id": 715,
        "price": 60000,
        "amount": 12,
        "name": "Буррата",
        "category": "salads",
        "image": "yoq"
    },
    {
        "id": 13,
        "price": 35000,
        "amount": 12,
        "name": "цезарь с курицей",
        "category": "salads",
        "desc": "Айсберг, помидоры черри, куриное филе, сухарики, сыр, соус Цезарь.",
        "image": "https://files.fm/thumb_show.php?i=65zv6f3rd"
    },
    {
        "id": 14,
        "price": 48000,
        "amount": 12,
        "name": "салат медовый",
        "category": "salads",
        "desc": "",
        "image": "https://files.fm/thumb_show.php?i=fhejj4kq2"
    },
    {
        "id": 15,
        "price": '30000',
        "amount": 12,
        "name": "крабовый салат",
        "category": "salads",
        "desc": "Крабовые палочки, яйца, огурцы, майонез",
        "image": "https://files.fm/thumb_show.php?i=e7r6c6hp8"
    },
    {
        "id": 16,
        "price": 45000,
        "amount": 12,
        "name": "Салат с тунцом",
        "category": "salads",
        "desc": "",
        "image": "https://files.fm/thumb_show.php?i=vc4udtu9cx"
    },
    {
        "id": 17,
        "price": 14000,
        "amount": 12,
        "name": "Сюзьма",
        "category": "salads",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=6zj9mh42y"
    },
    {
        "id": 18,
        "price": 14000,
        "amount": 12,
        "name": "Ачи-чучук",
        "category": "salads",
        "desc": "Помидоры, лук красный, базилик, райхон.",
        "image": "https://files.fm/thumb_show.php?i=ebhmec3qz"
    },
    {
        "id": 19,
        "price": 23000,
        "amount": 12,
        "name": "Овощное ассорти",
        "category": "salads",
        "desc": "Помидоры \n" +
            "Огурцы \n" +
            "Перец\n" +
            "Чеснок \n" +
            "Зелень\n" +
            "Лист салата",
        "image": "https://files.fm/thumb_show.php?i=gntx999ha"
    },
    {
        "id": 20,
        "price": 17000,
        "amount": 12,
        "name": "Ассорти маринованное",
        "category": "salads",
        "desc": "Черри \n" +
            "Огурцы \n" +
            "Патиссон",
        "image": "https://files.fm/thumb_show.php?i=fwbq6gu76"
    },
    {
        "id": 21,
        "price": 97000,
        "amount": 12,
        "name": "Фруктовое ассорти",
        "category": "salads",
        "desc": "Яблоко \n" +
            "Апельсин \n" +
            "Груша \n" +
            "Банан \n" +
            "Киви \n" +
            "Виноград",
        "image": "https://files.fm/thumb_show.php?i=exxfks7dy"
    },
    {
        "id": 22,
        "price": 100000,
        "amount": 12,
        "name": "Мясное ассорти",
        "category": "salads",
        "desc": "Рулет \n" +
            "Казы \n" +
            "Язык \n" +
            "Индейка",
        "image": "https://files.fm/thumb_show.php?i=zd52p9jhz"
    },
    {
        "id": 23,
        "price": 15000,
        "amount": 12,
        "name": "Солёное ассорти",
        "category": "salads",
        "desc": "Кимчи\n" +
            "Огурцы \n" +
            "Помидоры \n" +
            "Армянская капуста",
        "image": "https://files.fm/thumb_show.php?i=kds8nmcjv"
    },
    {
        "id": 24,
        "price": 20000,
        "amount": 12,
        "name": "чечевичный суп",
        "category": "soups",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=wwx9kqe5q"
    },
    {
        "id": 25,
        "price": 20000,
        "amount": 12,
        "name": "Куриный бульон",
        "category": "soups",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=jr9j38jsq"
    },
    {
        "id": 26,
        "price": 20000,
        "amount": 12,
        "name": "куриный фрикадельки",
        "category": "soups",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=wwnn3wtk4"
    },
    {
        "id": 27,
        "price": 30000,
        "amount": 12,
        "name": "KFC стрипсы",
        "category": "meals",
        "desc": "1кг - 100.000 / 300гр - 30000",
        "image": "https://files.fm/thumb_show.php?i=5mjz2w5uw"
    },
    {
        "id": 28,
        "price": 28000,
        "amount": 12,
        "name": "KFC Қанотчалар",
        "category": "meals",
        "desc": "1кг - 95.000 / 300гр - 28000",
        "image": "https://files.fm/thumb_show.php?i=cjxfbcxvq"
    },
    {
        "id": 29,
        "price": 28500,
        "amount": 12,
        "name": "Товуқ қанотчалари",
        "category": "meals",
        "desc": "1кг - 95.000 / 300гр - 28500",
        "image": "https://files.fm/thumb_show.php?i=n4d5she6e"
    },
    {
        "id": 30,
        "price": 28500,
        "amount": 12,
        "name": "товуқ болдир",
        "category": "meals",
        "desc": "1кг - 95.000 / 300гр - 28500",
        "image": "https://failiem.lv/thumb_show.php?i=f398wcvyz"
    },
    {
        "id": 31,
        "price": 28500,
        "amount": 12,
        "name": "Жужа микс", ///////////////
        "category": "meals",
        "desc": "1кг - 95.000 / 300гр - 28500",
        "image": "https://files.fm/thumb_show.php?i=s4tyjbpjm"
    },
    {
        "id": 32,
        "price": 27000,
        "amount": 12,
        "name": "соф жyжа",
        "category": "meals",
        "desc": "1кг - 90.000 / 300гр - 27000",
        "image": "https://failiem.lv/thumb_show.php?i=u7spmj223"
    },
    {
        "id": 33,
        "price": 42000,
        "amount": 12,
        "name": "балиқ сазан",
        "category": "meals",
        "desc": "1кг - 140.000 / 300гр - 42000",
        "image": "https://failiem.lv/thumb_show.php?i=gx49ezmg2"
    },
    {
        "id": 34,
        "price": 42000,
        "amount": 12,
        "name": "балиқ судак",
        "category": "meals",
        "desc": "1кг - 140.000 / 300гр - 42000",
        "image": "https://failiem.lv/thumb_show.php?i=syk97yczd"
    },
    {
        "id": 35,
        "price": 16000,
        "amount": 12,
        "name": "фри",
        "category": "meals",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=5qa6yzstv"
    },
    {
        "id": 36,
        "price": 129000,
        "amount": 12,
        "name": "Тибон стейк", ///////////////
        "category": "mangal",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=xvpcxdstp"
    },
    {
        "id": 37,
        "price": 119000,
        "amount": 12,
        "name": "Рибай стейк", //////////////
        "category": "mangal",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=ks2myejev"
    },
    {
        "id": 38,
        "price": 75000,
        "amount": 12,
        "name": "Медальон",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=n64ch6v87"
    },
    {
        "id": 39,
        "price": 41000,
        "amount": 12,
        "name": "классик кофте",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=uy44492uy"
    },
    {
        "id": 40,
        "price": 43000,
        "amount": 12,
        "name": "кашарли кофте",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=fgpjc6q9y"
    },
    {
        "id": 41,
        "price": 52000,
        "amount": 12,
        "name": "чизбургер",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=yxqdntb2k"
    },
    {
        "id": 42,
        "price": 54000,
        "amount": 12,
        "name": "мексиканский бургер",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=hez5t5yhm"
    },
    {
        "id": 721,
        "price": 700000,
        "amount": 12,
        "name": "Шохона ассорти",
        "category": "asarti",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=73m4m2e2nh"
    },
    {
        "id": 722,
        "price": 80000,
        "amount": 12,
        "name": "Тибон мини",
        "category": "mangal",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=xg4k298e5b"
    },
    {
        "id": 723,
        "price": 28000,
        "amount": 12,
        "name": "Кидс бургер",
        "category": "mangal",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=xhbvtvq9qz"
    },
    {
        "id": 724,
        "price": 15000,
        "amount": 12,
        "name": "Печень рулет",
        "category": "mangal",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 725,
        "price": 17000,
        "amount": 12,
        "name": "mолотый рулет",
        "category": "mangal",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 725,
        "price": 17000,
        "amount": 12,
        "name": "Баранина шашлык",
        "category": "mangal",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 725,
        "price": 18000,
        "amount": 12,
        "name": "Наполеон шашлык",
        "category": "mangal",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 43,
        "price": 35000,
        "amount": 12,
        "name": "кебаб на шпажках",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=ywtam8gda"
    },
    {
        "id": 44,
        "price": 79000,
        "amount": 12,
        "name": "Алькапон",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=8yfbdgxyp"
    },
    {
        "id": 45,
        "price": 95000,
        "amount": 12,
        "name": "Қалқон Кофте",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=fuzrsjeaf"
    },
    {
        "id": 46,
        "price": 38000,
        "amount": 12,
        "name": "урфа кебаб",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=kurn3rrqh"
    },
    {
        "id": 47,
        "price": 40000,
        "amount": 12,
        "name": "Сосиски на мангале",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=sbrxqry8k"
    },
    {
        "id": 48,
        "price": 13000,
        "amount": 12,
        "name": "қийма шашлик",
        "category": "mangal",
        "desc": "100g ",
        "image": "https://failiem.lv/thumb_show.php?i=73whn5skg"
    },
    {
        "id": 49,
        "price": 40000,
        "amount": 12,
        "name": "изгара chicken",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=2hep2msdp"
    },
    {
        "id": 50,
        "price": 16000,
        "amount": 12,
        "name": "жаз кебаб",
        "category": "mangal",
        "desc": "100g",
        "image": "https://failiem.lv/thumb_show.php?i=e8b7fjqks"
    },
    {
        "id": 51,
        "price": 75000,
        "amount": 12,
        "name": "корейка на мангале",
        "category": "mangal",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=v82am524b"
    },
    {
        "id": 151,
        "price": 44000,
        "amount": 12,
        "name": "Крылья на мангале",
        "category": "mangal",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=937azunr7"
    },
    {
        "id": 152,
        "price": 120000,
        "amount": 12,
        "name": "Мини бургеры",
        "category": "mangal",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=qn636ufsd"
    },
    {
        "id": 52,
        "price": 350000,
        "amount": 12,
        "name": "Соф ассорти",
        "category": "asarti",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=k8c96973s"
    },
    {
        "id": 53,
        "price": 400000,
        "amount": 12,
        "name": "Aссорти мини кебаб",
        "category": "asarti",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=64ex4qc4e"
    },
    {
        "id": 54,
        "price": 600000,
        "amount": 12,
        "name": "Aссорти биг кебаб",
        "category": "asarti",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=ctk52f3rk"
    },
    {
        "id": 55,
        "price": 28000,
        "amount": 12,
        "name": "Ягодно-фисташковый",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=h5zq2srzs"
    },
    {
        "id": 56,
        "price": 25000,
        "amount": 12,
        "name": "Яблочный торт",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=mfwqts5md"
    },
    {
        "id": 57,
        "price": 25000,
        "amount": 12,
        "name": "Торт Тирамису",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=fwwzj9dse"
    },
    {
        "id": 58,
        "price": 25000,
        "amount": 12,
        "name": "сливочный медовик",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=89c624t9n"
    },
    {
        "id": 59,
        "price": 25000,
        "amount": 12,
        "name": "чиз-Брауни",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=adn679nfv"
    },
    {
        "id": 60,
        "price": 25000,
        "amount": 12,
        "name": "опера",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=e3b99yc9s"
    },
    {
        "id": 61,
        "price": 25000,
        "amount": 12,
        "name": "три шоколада",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=9q3tk9xx6"
    },
    {
        "id": 62,
        "price": 25000,
        "amount": 12,
        "name": "карамельный чизкейк",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=e56kxrcrj"
    },
    {
        "id": 63,
        "price": 25000,
        "amount": 12,
        "name": "клубничный Чизкейк",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=e9t37fnps"
    },
    {
        "id": 64,
        "price": 25000,
        "amount": 12,
        "name": "шоколадный чизкейк",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=rn454sw2c"
    },
    {
        "id": 65,
        "price": 25000,
        "amount": 12,
        "name": "классический медовик",
        "category": "sweets",
        "desc": " ",
        "image": "https://failiem.lv/thumb_show.php?i=fgpswya46"
    },
    {
        "id": 699,
        "price": 45000,
        "amount": 12,
        "name": "Ассорти Гонконг",
        "category": "sweets",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 700,
        "price": 45000,
        "amount": 12,
        "name": "Бельгийские вафли фруктовый микс, мороженое",
        "category": "sweets",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 701,
        "price": 42000,
        "amount": 12,
        "name": "Гонгконг вафли фруктовый микс, мороженое",
        "category": "sweets",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 702,
        "price": 38000,
        "amount": 12,
        "name": "Бельгийские вафли фруктовый микс",
        "category": "sweets",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=vrsmjyrusp"
    },
    {
        "id": 703,
        "price": 36000,
        "amount": 12,
        "name": "Гонгконг вафли фруктовый микс",
        "category": "sweets",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=ymcjdy8epr"
    },
    {
        "id": 704,
        "price": 34000,
        "amount": 12,
        "name": "Бельгийские вафли с бананом",
        "category": "sweets",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 705,
        "price": 32000,
        "amount": 12,
        "name": "Гонгконг вафли с бананом",
        "category": "sweets",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=h74fvsfbsp"
    },
    {
        "id": 706,
        "price": 30000,
        "amount": 12,
        "name": "Бельгийские вафли с шоколадом",
        "category": "sweets",
        "desc": " ",
        "image": "yoq"
    },
    {
        "id": 707,
        "price": 28000,
        "amount": 12,
        "name": "Гонгконг вафли с шоколадом",
        "category": "sweets",
        "desc": " ",
        "image": "https://files.fm/thumb_show.php?i=c3yux258z7"
    },
    {
        "id": 66,
        "price": 30000,
        "amount": 12,
        "name": "чай малина розмарин",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=en27f5yfv"
    },
    {
        "id": 67,
        "price": 33000,
        "amount": 12,
        "name": "чай смородиной чабрец",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=7ug2enjvk"
    },
    {
        "id": 68,
        "price": 35000,
        "amount": 12,
        "name": "чай фруктовый",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=jxhjrqjgx"
    },
    {
        "id": 69,
        "price": 30000,
        "amount": 12,
        "name": "чай ягодный",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=7ug2enjvk"
    },
    {
        "id": 70,
        "price": 20000,
        "amount": 12,
        "name": "чай ройбуш-апельсин",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=tmg3yjurz"
    },
    {
        "id": 71,
        "price": 20000,
        "amount": 12,
        "name": "Марокканский чай",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=tmg3yjurz"
    },
    {
        "id": 72,
        "price": 20000,
        "amount": 12,
        "name": "чай имбирь с лимоном",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=tmg3yjurz"
    },
    {
        "id": 73,
        "price": 20000,
        "amount": 12,
        "name": "Чай жасмин",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=943ezm7sb"
    },
    {
        "id": 74,
        "price": 5000,
        "amount": 12,
        "name": "Чёрный чай",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=943ezm7sb"
    },
    {
        "id": 75,
        "price": 5000,
        "amount": 12,
        "name": "Зеленый чай",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=943ezm7sb"
    },
    {
        "id": 76,
        "price": 10000,
        "amount": 12,
        "name": "Чай с лимоном",
        "category": "tea",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=943ezm7sb"
    },
    {
        "id": 77,
        "price": 20000,
        "amount": 12,
        "name": "cappuccino",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=gavfn2bem"
    },
    {
        "id": 78,
        "price": 17000,
        "amount": 12,
        "name": "espresso",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=4ggnmcxd9"
    },
    {
        "id": 79,
        "price": 17000,
        "amount": 12,
        "name": "americano",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=aan7cd8j6"
    },
    {
        "id": 80,
        "price": 20000,
        "amount": 12,
        "name": "glasse",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=aan7cd8j6"
    },
    {
        "id": 81,
        "price": 17000,
        "amount": 12,
        "name": "ice americano",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=aan7cd8j6"
    },
    {
        "id": 82,
        "price": 20000,
        "amount": 12,
        "name": "ice cappuccino",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=aan7cd8j6"
    },
    {
        "id": 83,
        "price": 20000,
        "amount": 12,
        "name": "latte",
        "category": "coffee",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=wkqvt24hh"
    },
    {
        "id": 84,
        "price": 8000,
        "amount": 12,
        "name": "Шиповник",
        "category": "drinks",
        "type": "contain",
        "desc": "Графин 15000 Стакан 8000 ",
        "image": "https://failiem.lv/thumb_show.php?i=vk8n2cnzr"
    },
    {
        "id": 85,
        "price": 25000,
        "amount": 12,
        "name": "айс-ти",
        "category": "drinks",
        "desc": " 1l - 45000",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=txqa65yez"
    },
    {
        "id": 86,
        "price": 25000,
        "amount": 12,
        "name": "мохито классик",
        "category": "drinks",
        "desc": " 1l - 45000",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=zkw6nmbax"
    },
    {
        "id": 87,
        "price": 25000,
        "amount": 12,
        "name": "мохито энерджи",
        "category": "drinks",
        "desc": " 1l - 45000",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=zkw6nmbax"
    },
    {
        "id": 88,
        "price": 20000,
        "amount": 12,
        "name": "Голубая лагуна",
        "category": "drinks",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=dfxpc9z9b"
    },
    {
        "id": 89,
        "price": 20000,
        "amount": 12,
        "name": "чита",
        "category": "drinks",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=eeg7k6tn5"
    },
    {
        "id": 90,
        "price": 25000,
        "amount": 12,
        "name": "тархун",
        "category": "drinks",
        "desc": " 1l - 45000 ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=354pxxyhh"
    },
    {
        "id": 91,
        "price": 20000,
        "amount": 12,
        "name": "Яблочные",
        "category": "fresh",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=rb2pngnf8"
    },
    {
        "id": 92,
        "price": 15000,
        "amount": 12,
        "name": "морковный",
        "category": "fresh",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=dbra65pdk"
    },
    {
        "id": 93,
        "price": 35000,
        "amount": 12,
        "name": "апельсиновый",
        "category": "fresh",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=xfynz3xbp"
    },
    {
        "id": 94,
        "price": 40000,
        "amount": 12,
        "name": "Яблочно-апельсиновый",
        "category": "fresh",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=xfynz3xbp"
    },
    {
        "id": 95,
        "price": 30000,
        "amount": 12,
        "name": "лимонный",
        "category": "fresh",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=tznbp4gec"
    },
    {
        "id": 96,
        "price": 30000,
        "amount": 12,
        "name": "клубника яблоко смузи",
        "category": "smooth",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=2zqx3ezad"
    },
    {
        "id": 97,
        "price": 40000,
        "amount": 12,
        "name": "киви ананас смузи",
        "category": "smooth",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=9qg8kkynm"
    },
    {
        "id": 98,
        "price": 35000,
        "amount": 12,
        "name": "Банановое небо смузи",
        "category": "smooth",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=9qg8kkynm"
    },
    {
        "id": 99,
        "price": 35000,
        "amount": 12,
        "name": "апельсиновый смузи",
        "category": "smooth",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=ztgvc6ydu"
    },
    {
        "id": 100,
        "price": 37000,
        "amount": 12,
        "name": "манго - маракуйя Смузи",
        "category": "smooth",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=ztgvc6ydu"
    },
    {
        "id": 101,
        "price": 25000,
        "amount": 12,
        "name": "Шоколадный шейк",
        "category": "sheyk",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=ufakz62uk"
    },
    {
        "id": 102,
        "price": 20000,
        "amount": 12,
        "name": "Банановый шейк",
        "category": "sheyk",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=kdv7g55tx"
    },
    {
        "id": 103,
        "price": 20000,
        "amount": 12,
        "name": "малиновый шейк",
        "category": "sheyk",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=jyt5xbadp"
    },
    {
        "id": 104,
        "price": 20000,
        "amount": 12,
        "name": "клубничный шейк",
        "category": "sheyk",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=jyt5xbadp"
    },
    {
        "id": 105,
        "price": 20000,
        "amount": 12,
        "name": "Ягодный микс шейк",
        "category": "sheyk",
        "desc": " ",
        "type": "contain",
        "image": "https://failiem.lv/thumb_show.php?i=jyt5xbadp"
    },


];
export const Other = [
    {
        "id": 106,
        "category": " ",
        "name": "Пепси",
        "image": "https://files.fm/thumb_show.php?i=8h47sq3gb",
        "desc": "0,5л(баклажка) - 7000, 0,25л(баночное) - 10000, 1л(баклажка) - 11000, 1,5л(баклажка) - 15000",

    },
    {
        "id": 107,
        "category": " ",
        "name": "Coca Cola",
        "image": "https://files.fm/thumb_show.php?i=m26aarkba",
        "desc": "0,5л(баклажка) - 7000, 0,25л(баночное) - 10000, 0,25л(бутылочное) - 10000, 1л(баклажка) - 11000, 1,5л(баклажка) - 15000",
    },
    {
        "id": 108,
        "category": " ",
        "name": "Sprite",
        "image": "https://files.fm/thumb_show.php?i=u3pn6geyr",
        "desc": "0,5л(баклажка) - 7000, 0,25л(баночное) - 10000, 0,25л(бутылочное) - 10000, 1л(баклажка) - 11000, 1,5л(баклажка) - 15000",
    },
    {
        "id": 109,
        "category": " ",
        "name": "Fanta",
        "image": "https://files.fm/thumb_show.php?i=z5zy68brp",
        "desc": "0,5л(баклажка) - 7000, 0,25л(баночное) - 10000, 0,25л(бутылочное) - 10000, 1л(баклажка) - 11000, 1,5л(баклажка) - 15000",
    },
    {
        "id": 110,
        "category": " ",
        "name": "Barjomi",
        "image": "https://files.fm/thumb_show.php?i=vykpzr4zt",
        "desc": "0,5л(бутылочное) - 18000, 0,33л(баночное) - 10000"
    },
    {
        "id": 111,
        "category": " ",
        "name": "Chortoq",
        "image": "https://files.fm/thumb_show.php?i=h2nbvmfbm",
        "desc": "0,25л(бутылочное) - 6500, 0,33л(бутылочное) - 8000, 0,5л(бутылочное) - 10000, 0,75л(бутылочное) - 15000",
    },
    {
        "id": 112,
        "category": " ",
        "name": "Hydrolife",
        "image": "https://files.fm/thumb_show.php?i=s5c8c9uxp",
        "desc": "0,5л(баклажка) - 2500,\n" +
            "1,5л(баклажка) - 4500",
    },
    {
        "id": 113,
        "category": " ",
        "image": "https://files.fm/thumb_show.php?i=p2bd9ahre",
        "name": "Cок Viko - 1л ",
        "price": 18000
    },

];

